import React, { useMemo, useState, useEffect } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { useTheme } from '../../ThemeContext'; // Adjust the path as necessary
import { viewIssues, changeIssueStatus } from '../../api/api';
import AddIssues from '../AddIssues';
import { MantineProvider } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { PencilIcon, EyeIcon, TrashIcon,ChatBubbleLeftRightIcon} from '@heroicons/react/24/outline';
import Comments from '../Comments/AddComments';
import { formatDate } from '../../api/services';

export const Example = ({ handlePageUpdate, updatePage }) => {
  const navigate = useNavigate();
  const { theme } = useTheme(); // Get the theme from context
  const [data, setData] = useState([]);
  const [editing, setEditing] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [statusChange,setStatusChange]=useState(false)
//console.log(data)
  // Columns definition
  const columns = useMemo(() => [
    {
      accessorKey: 'project_id.project_name',
      header: 'Project Name',
      Cell: ({ cell }) => cell.getValue() || 'N/A',
    },
    {
      accessorKey: 'title',
      header: 'Title',
      Cell: ({ cell }) => cell.getValue() || 'N/A',
    },
    {
      accessorKey: 'description',
      header: 'Description',
    },
    {
      accessorKey: 'deadline',
      header: 'Deadline',
      Cell: ({ row }) => formatDate(row.original.deadline) || 'N/A',
    },
    {
      accessorKey: 'issue_status',
      header: 'Status',
      Cell: ({ row }) => {
        return (
          <div
            onClick={() => handleChangeStatus(row)}
            style={{ cursor: 'pointer' }}
          >
            {row.getValue('issue_status') === 'Resolved' ? (
              <span className="text-green-500">Resolved</span>
            ) : (
              <span className="text-red-500">Pending</span>
            )}
          </div>
        );
      },
    },
    {
      header: 'Actions',
      Cell: ({ row }) => (
        <div className="flex gap-2">
        
         
          <ChatBubbleLeftRightIcon
            className="w-5 h-5 text-blue-600 hover:text-red-800 cursor-pointer"
            onClick={() => openComment(row)}
          />
        </div>
      ),
    },
  ], []);

  // Edit row handler
  const handleEditRow = (row) => {
    setEditingRow(row.original);
    setEditing(true);
  };
  // Delete modal handler
  const openComment = (row) => {
    setRowToDelete(row.original);
    setIsCommentOpen(true);
  };
  const handleChangeStatus = async (row) => {
    // console.log(row.original._id,'i am row')
    setStatusChange(true) 
    try {
      // Change the user's status via API
      const res =await changeIssueStatus(row.original._id);
      // console.log(res.data)
      handlePageUpdate()
      setStatusChange(false)
    } catch (error) {
      console.error('Error changing issue status:', error);
    }
  };


  // Fetch data when updatePage changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await viewIssues();
        setData(response.data.issues || []);
        //console.log(response.data.issues)
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [handlePageUpdate]);

  // Initialize the Mantine React Table with custom styling
  const table = useMantineReactTable({
    columns,
    data,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableRowNumbers: true,
    mantineTableProps: {
      highlightOnHover: true,
      withBorder: true,
      sx: {
        'thead > tr': {
          backgroundColor: theme === 'dark' ? '#1a202c' : '#f7fafc',
        },
        'thead > tr > th': {
          backgroundColor: theme === 'dark' ? '#2d3748' : '#edf2f7',
          color: theme === 'dark' ? '#e2e8f0' : '#2d3748',
        },
        'tbody > tr': {
          '&:hover': {
            backgroundColor: theme === 'dark' ? '#2d3748' : '#f1f5f9',
          },
        },
        'tbody > tr > td': {
          backgroundColor: theme === 'dark' ? '#2d3748' : '#ffffff',
          color: theme === 'dark' ? '#ffff' : '#333333',
        },
      },
    },
  });

  return (
    <MantineProvider
      theme={{
        colorScheme: theme,
        primaryColor: 'blue',
        primaryShade: 5,
      }}
    >
      <MantineReactTable table={table} />
      
      {/* Conditional Rendering for Add User Form */}
      {editing && (
        <AddIssues
          isEditing={editing}
          setEditing={setEditing}
          userDetails={editingRow}
          handlePageUpdate={handlePageUpdate}
        />
      )}

      {/* Delete Confirmation Modal */}
      {isCommentOpen && rowToDelete && (
        <Comments
          isOpen={isCommentOpen}
          setIsOpen={setIsCommentOpen}
          meetingId={rowToDelete._id}
          projectId={rowToDelete.project_id}
          type={'issues'}
          name={'Issue Comments'}
        />
      )}
    </MantineProvider>
  );
};

export default Example;
